import React, { useEffect, createElement } from 'react';
import { Toaster } from 'sonner';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Modules } from '../components/Modules';
import { BonusTestimonials } from '../components/BonusTestimonials';
import { Bonuses } from '../components/Bonuses';
import { ComparisonTable } from '../components/ComparisonTable';
import { Testimonials } from '../components/Testimonials';
import { UrgencyTimer } from '../components/UrgencyTimer';
import { Checkout } from '../components/Checkout';
import { Objections } from '../components/Objections';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function SalesPage() {
  useEffect(() => {
    // Initialize Meta Pixel
    const PIXEL_ID = '1252242806993118';
    const w = window as any;
    if (!w.fbq) {
      ;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(w, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-cream via-warm-neutral to-pale-blue" data-id="element-168" data-mp="286atigbzehen">
      <Header data-id="element-169" data-mp="243efz41atbhk" />
      <Hero data-id="element-170" data-mp="242v15w6y337r" />
      <PainPoints data-id="element-171" data-mp="24236cnl699ij" />
      <Modules data-id="element-172" data-mp="2460ph97r212f" />
      <BonusTestimonials data-id="element-173" data-mp="25ktkm5i6rd5e" />
      <Bonuses data-id="element-174" data-mp="25kjwyokm5i2v" />
      <ComparisonTable data-id="element-175" data-mp="25m4pk8ndaqy3" />
      <Testimonials data-id="element-176" data-mp="25iqnl1im8jr6" />
      <UrgencyTimer data-id="element-177" data-mp="2ajwgp0g6u918" />
      <Checkout data-id="element-178" data-mp="2akg06llhl5hd" />
      <Objections data-id="element-179" data-mp="2aiv770etlulm" />
      <Footer data-id="element-180" data-mp="2ajeezoarb2lx" />
      <PurchasePopup data-id="element-181" data-mp="2ahtt0n2icrzo" />
      <Toaster richColors data-id="element-182" data-mp="1vmnmlyzi2r5t" />
    </div>;
}